import { useAuth } from "@/context/AuthContext";
import { type PermissionModules, Permissions } from "@/utils/permissions";

export function usePermission() {
	const { user } = useAuth();

	const can = (module: PermissionModules, action: string) => {
		if (!user?.role) {
			return false;
		}

		const rolesArray = Array.isArray(user.role) ? user.role : [user.role];

		return rolesArray.some((roleName) => {
			const rules = Permissions[roleName as keyof typeof Permissions];
			return rules?.[module]?.includes(action) ?? false;
		});
	};

	return { can };
}
